// Generate time slots in 15-minute increments
export const generateTimeSlots = (startHour = 6, endHour = 22) => {
  const slots = [];
  for (let h = startHour; h <= endHour; h++) {
    for (let m of [0, 15, 30, 45]) {
      slots.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
    }
  }
  return slots;
};

export const ALL_TIME_SLOTS = generateTimeSlots(6, 22);

// Format HH:MM into 12-hour display string
export const formatTime12 = (time24) => {
  if (!time24) return '';
  const [h, m] = time24.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
};

// Calculate hours between two HH:MM times (15-min precision)
export const hoursBetween = (start, end) => {
  if (!start || !end) return 0;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  const diff = (eh * 60 + em) - (sh * 60 + sm);
  return Math.max(Math.round(diff / 15) * 15 / 60, 0);
};

// Filter end times to only those after start
export const endTimesFor = (startTime) => {
  if (!startTime) return ALL_TIME_SLOTS;
  return ALL_TIME_SLOTS.filter(t => t > startTime);
};
